import script from "./ExperienceSection.vue?vue&type=script&setup=true&lang=js"
export * from "./ExperienceSection.vue?vue&type=script&setup=true&lang=js"

import "./ExperienceSection.vue?vue&type=style&index=0&id=03445934&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-03445934"]])

export default __exports__